export default "__VITE_ASSET__BmqQh9LR__"